import React, { useState } from 'react';
import { DECK, DeckOffer } from './DeckReshuffle';

const QuickCheckDemo: React.FC = () => {
  const [query, setQuery] = useState('');
  const [result, setResult] = useState<DeckOffer | 'none' | null>(null);
  const [dealt, setDealt] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const q = query.trim().toLowerCase();
    if (!q) return;
    const match = DECK.find(d => d.merchant.toLowerCase().includes(q));
    setDealt(false);
    setResult(match ?? 'none');
    requestAnimationFrame(() => {
      requestAnimationFrame(() => setDealt(true));
    });
  };

  return (
    <div className="cache__qc">
      <form className="cache__qc-bar" onSubmit={handleSubmit}>
        <input
          className="cache__qc-input"
          type="text"
          placeholder="Try “Starbucks” or “Delta”…"
          value={query}
          onChange={e => setQuery(e.target.value)}
          aria-label="Search for a merchant"
        />
        <button className="cache__qc-submit" type="submit">Check</button>
      </form>

      <div className="cache__qc-result">
        {result === null && (
          <span className="cache__qc-hint">Type a merchant your cards might have an offer with.</span>
        )}
        {result === 'none' && (
          <span className="cache__qc-hint">No active offer found for “{query}.”</span>
        )}
        {result && result !== 'none' && (
          <div className={`cache__qc-card ${dealt ? 'is-dealt' : ''}`}>
            <div className="cache__offercard-top">
              <span className={`cache__deck-tag cache__deck-tag--${result.category}`}>{result.category}</span>
              <span className={`cache__deck-dot cache__deck-dot--${result.fresh}`} aria-hidden="true" />
            </div>
            <div className="cache__deck-brand">
              <img className="cache__deck-logo" src={result.logo} alt="" aria-hidden="true" />
              <div className="cache__deck-merchant">{result.merchant}</div>
            </div>
            <div className="cache__deck-value">{result.value}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default QuickCheckDemo;
